import { useTranslations } from "@acto/web-common/locales";
import { MetricCard } from "../../ui";
import { styled } from "@pigment-css/react";
import type { WorkflowMetrics as WorkflowMetricsType } from "@acto/taskpane/core/data-access/workflow";

const Grid = styled("div")(({ theme }) => ({
  position: "relative",
  width: "100%",
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr 1fr",
  gap: theme.managementView.spacing[16],
}));

interface WorkflowMetricsProps {
  metrics: WorkflowMetricsType;
}

export const WorkflowMetrics = ({ metrics }: WorkflowMetricsProps) => {
  const t = useTranslations("managementView.workflowDetails");

  return (
    <Grid>
      <MetricCard label={t("created")} value={String(metrics.created)} change={metrics.createdChange} />
      <MetricCard label={t("deleted")} value={String(metrics.deleted)} change={metrics.deletedChange} />
      <MetricCard label={t("completed")} value={String(metrics.completed)} change={metrics.completedChange} />
      <MetricCard label={t("overdue")} value={String(metrics.overdue)} change={metrics.overdueChange} />
    </Grid>
  );
};
